<template>
  <Modal ref="modalRef" class="" :ok-disabled="!canSaveChanges()" @ok="saveChanges">
    <template #title>Contact info</template>
    <ContactInfo ref="contactInfoRef" :user-id="userIdRef" :disabled="busyRef"/>
  </Modal>
</template>

<style lang="scss" scoped>
</style>

<script lang="ts" setup>
import { ref } from 'vue'
import Modal from '@/util/Modal.vue'
import ContactInfo from './ContactInfo.vue'

defineExpose({
  open,
})

const userIdRef = ref<string>()
const busyRef = ref(false)

const modalRef = ref<InstanceType<typeof Modal>>()
const contactInfoRef = ref<InstanceType<typeof ContactInfo>>()


function open(userId: string) {
  userIdRef.value = userId
  modalRef.value?.open()
}

function canSaveChanges() {
  return contactInfoRef.value?.canSave()
}

async function saveChanges() {
  try {
    busyRef.value = true
    await contactInfoRef.value?.saveAsync()
    await modalRef.value?.close()
  }
  finally {
    busyRef.value = false
  }
}
</script>
